import { type ReactNode } from 'react';

export interface PageHeaderProps {
  eyebrow?: string;
  title: ReactNode;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ eyebrow, title, description, actions }: PageHeaderProps) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div>
        {eyebrow && <p className="mb-2 text-eyebrow uppercase text-muted">{eyebrow}</p>}
        <h1 className="font-display text-display-md text-ink">{title}</h1>
        {description && <p className="mt-2 max-w-xl text-sm text-ink-soft">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}
